import { render } from "./Create.vue?vue&type=template&id=3dde4047"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/heidbyte/code/GitHub/festivalkult/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__